<template>
  <div>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field v-model="bdcqzm.bDCDYH" label="不动产单元号" readonly/>
        <van-field v-model="bdcqzm.bDCQZMH" label="不动产登记证明" readonly/>
        <van-field v-model="bdcqzm.bH" label="编号" readonly/>
        <van-field v-model="bdcqzm.iID" label="业务号" readonly/>
        <van-field v-model="bdcqzm.qLRMC" label="权利人名称" readonly/>
        <van-field v-model="bdcqzm.qLRZJMC" label="权利人证件类型" readonly/>
        <van-field v-model="bdcqzm.qLRZJHM" label="权利人证件号码" readonly/>
        <van-field v-model="bdcqzm.yWRMC" label="义务人名称" readonly/>
        <van-field v-model="bdcqzm.zL" label="坐落" type="textarea" autosize readonly/>
        <van-field v-model="bdcqzm.qT" label="附记" type="textarea" autosize readonly/>
        <van-field v-model="bdcqzm.dJSJ" label="登记时间" readonly/>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { getAtbdcqzm } from '@/api/atbdcqzm.js'
export default {
  filters: {
  },
  data() {
    return {
      bdcqzm:{}
    };
  },
  computed: {
  },
  created() {
  },
  mounted() { 
    this.loadAtbdcqzm();
  },
  methods: {
    loadAtbdcqzm(){
      getAtbdcqzm({
        ywh: this.$route.query.ywh
      }).then(response => {
        this.bdcqzm = response.data
      })
    }
  },
};
</script>
<style scoped lang="scss">
</style>